module.exports = __webpack_public_path__ + "497501c8e880268bd68331588160f982.png";